"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationReadoutItemMixin = exports.PaginationItemMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Text = require("../../components/Text/Text.styles");
/** @class PaginationItemMixin */
/** @method */
var PaginationItemMixin = function PaginationItemMixin(props) {
  return (0, _styledToken.default)({
    marginX: 'PaginationItem.marginX',
    marginY: 'PaginationItem.marginY'
  }, function (_ref) {
    var marginX = _ref.marginX,
      marginY = _ref.marginY;
    return (0, _styledComponents.css)(["display:block;margin:", "px ", "px;"], marginY, marginX);
  })(props);
};

// The readout is the "Page x of x" label that appears on smaller screens
exports.PaginationItemMixin = PaginationItemMixin;
var PaginationReadoutItemMixin = function PaginationReadoutItemMixin(props) {
  return (0, _styledToken.default)('PaginationItem.textAlign', function (textAlign) {
    if (textAlign === void 0) {
      textAlign = 'center';
    }
    return (0, _styledComponents.css)(["& > ", "{text-align:", ";display:inline-block;}"], _Text.StyledText, textAlign);
  })(props);
};
exports.PaginationReadoutItemMixin = PaginationReadoutItemMixin;